import React from "react";
import Footer from "../../components/Footer";
import SubFooter from "../../components/SubFooter";
import Img from "../../assets/maya.jpg";
import HighestImg from "../../assets/courses/highest.gif";
import AvgImg from "../../assets/courses/avg.png";
import YearImg from "../../assets/courses/year.gif";
import { FaLeaf, FaHeartbeat, FaRecycle } from "react-icons/fa";

const stats = [
  {
    id: 1,
    name: "Highest Package",
    value: "43.5 Lakh",
    image: HighestImg,
  },
  { id: 2, name: "Average Package", value: "5.48 Lakh", image: AvgImg },
  { id: 3, name: "Years of Legacy", value: "14", image: YearImg },
];

const Mdef = () => {
  return (
    <div className="w-full relative min-h-screen pt-10">
      <h2
        className="text-2xl md:text-4xl tracking-tight mt-20 md:mt-35 font-bold text-center text-[#0e4d38]" style={{marginTop:"100px"}}
      >
        Maya Devi Educational Foundation
      </h2>
      {/* Main Card */}
      <div className="w-10/12 mx-auto flex flex-col md:flex-row justify-between items-center gap-8 mt-10 bg-white p-6 rounded-lg shadow-md border border-gray-200">
        <img
          src={Img}
          alt="Maya Devi University Logo"
          className="w-full md:w-1/3 rounded-lg"
        />
        <div className="text-justify text-gray-700 leading-relaxed">
          <p className="text-lg">
            Maya Devi Educational Foundation, established in the year 2000, is a
            non-profit society registered under the Society Registration Act 21,
            1860 (Registration No. – UK060031020200050008 Dated 8th March
            2000). Foundation believes in promoting a disciplined framework to
            prepare future innovators and entrepreneurs with tremendous
            strength and knowledge.
          </p>
          <br />
          <p className="text-lg">
            Maya Devi Educational Foundation is also involved in various social
            activities like organizing Free Medical Health Check-up Camps, Tree
            Plantation, and Cleanliness Drives in various places of Uttarakhand.
          </p>
        </div>
      </div>

      {/* <SubFooter /> */}
      <Footer />
    </div>
  );
};

export default Mdef;
